import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {PostOdontoCancel, PostOdontoCancelParams, PostOdontoCancelModel} from 'domain/usecases';

export class RemotePostOdontoCancel implements PostOdontoCancel {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostOdontoCancelModel>,
	) {}

	async post(params: PostOdontoCancelParams): Promise<PostOdontoCancelModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
